const removeDuplicateWordsFromText = (text: string, duplicate: string): string => {
    const clubWords = duplicate.toLowerCase().split(/\s+/)
    return text
        .split(/\s+/)
        .filter(word => !clubWords.includes(word.toLowerCase()))
        .join(' ')
}

export default removeDuplicateWordsFromText
